import { createFileRoute } from '@tanstack/react-router'
import { BuildsIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/progetti/')({
  loader: () => loadPageData({ data: { kind: 'builds', locale: 'it' } }),
  head: () => staticRouteHead('builds', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <BuildsIndexPage />
    </CatalogProvider>
  )
}
